import React from 'react';
import { Accordion } from '../common/components';
import Body from './AccordionBody';

const InformazioniServizio = ({ Form }) => (
  <Accordion
    titolo="Informazioni Corso"
    Body={Body}
    Form={Form}
  >
  </Accordion>
    );

InformazioniServizio.displayName = 'Accordion Informazioni Servizio';

export default InformazioniServizio;
